<template>
  <div class="row">
    <div class="col-12 card" v-if="!postRequest && carDataLoaded">
      <div class="header-section">
        <h4 class="card-title">Редактировать автомобиль</h4>
        <div class="button-group">
          <router-link to="/"><button class="btn-secondary">Отменить</button></router-link>
          <button class="btn-primary" @click="updateCar">
            <span class="icon-Edit"></span>Сохранить изменения
          </button>
        </div>
      </div>

      <div class="form-section">
        <div class="text-field">
          <label class="text-field__label" for="carNumber">Гос. номер</label>
          <div class="text-field__icon">
            <input class="text-field__input" type="text" id="carNumber" v-model="orderCar" disabled>
          </div>
        </div>

        <div class="text-field">
          <label class="text-field__label" for="volume">Объём загрузки</label>
          <div class="text-field__icon">
            <input class="text-field__input" type="number" id="volume" placeholder="м3" v-model.number="orderCarVolume">
          </div>
        </div>

        <div class="text-field">
          <label class="text-field__label" for="compaction">Коэффициент уплотнения</label>
          <div class="text-field__icon">
            <input class="text-field__input" type="number" step="0.1" id="compaction" placeholder="например 1.1" v-model.number="orderCarCompaction">
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 card" v-if="loading">
      <div class="result-section"><h4 class="card-title">Загрузка данных...</h4></div>
    </div>

    <div class="col-12 card" v-if="postRequest">
      <div class="result-section">
        <h4 class="card-title">{{ backendResponse }}</h4>
        <div class="result-buttons">
          <button class="btn-primary" @click="postRequest = false" v-if="postError">Попробовать снова</button>
          <router-link to="/" v-else><button class="btn-primary">Вернуться на главную</button></router-link>
        </div>
      </div>
    </div>

    <div class="col-12 card" v-if="error">
      <div class="result-section">
        <h4 class="card-title">{{ error }}</h4>
        <div class="result-buttons">
          <router-link to="/"><button class="btn-primary">Вернуться на главную</button></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'EditCar',
  data() {
    return {
      title: 'Редактировать автомобиль',
      orderCar: '',
      orderCarVolume: null,
      orderCarCompaction: null,
      postError: false,
      postRequest: false,
      backendResponse: '',
      loading: false,
      carDataLoaded: false,
      error: null,
      carId: null
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user
    }
  },
  mounted() {
    document.title = this.title
    this.carId = this.$route.params.id || null
    this.loadCarDataFromStore()
  },
  methods: {
    loadCarDataFromStore() {
      const carData = this.$store.state.waste?.currentCar || this.$store.state.currentCar
      if (carData) {
        this.orderCar = this.formatCarNumberForDisplay(carData.CarNumber)
        this.orderCarVolume = Number(carData.CarVolume)
        this.orderCarCompaction = Number(carData.Compaction)
        this.carDataLoaded = true
      } else {
        this.loadCarDataFromQuery()
      }
    },
    loadCarDataFromQuery() {
      const { number, volume, compaction } = this.$route.query || {}
      if (number && volume && compaction) {
        this.orderCar = this.formatCarNumberForDisplay(number)
        this.orderCarVolume = Number(volume)
        this.orderCarCompaction = Number(compaction)
        this.carDataLoaded = true
      } else {
        this.error = 'Данные автомобиля не найдены'
        this.loading = false
      }
    },
    formatCarNumberForDisplay(carNumber) {
      if (!carNumber) return ''
      let formatted = ''
      for (let i = 0; i < carNumber.length; i++) {
        if (i === 1 || i === 4 || i === 6) formatted += ' '
        formatted += carNumber[i]
      }
      return formatted
    },
    getCleanNumber() {
      return String(this.orderCar || '').replace(/\s/g, '')
    },
    async updateCar() {
      // базовая валидация
      if (!this.orderCar.trim() || this.orderCarVolume == null || this.orderCarCompaction == null) {
        this.postRequest = true
        this.postError = true
        this.backendResponse = 'Заполните все обязательные поля'
        return
      }
      if (Number(this.orderCarVolume) <= 0 || Number(this.orderCarCompaction) <= 0) {
        this.postRequest = true
        this.postError = true
        this.backendResponse = 'Объём и коэффициент должны быть больше 0'
        return
      }

      const payload = {
        CarNumber: this.getCleanNumber().toUpperCase(),
        CarVolume: Number(this.orderCarVolume),
        Measurement: 'м3',
        Compaction: Number(this.orderCarCompaction)
      }

      this.postRequest = true
      this.postError = false

      try {
        // ВАЖНО: ручка на бэке — без :id в пути
        const url = `${this.$store.state.domain}/api/polygon/edit_car`
        const response = await axios.post(url, payload, {
          headers: { 'Content-Type': 'application/json' }
        })

        let responseText = ''
        if (typeof response.data === 'object') {
          responseText = response.data.answer || response.data.message || response.data.error || JSON.stringify(response.data)
        } else {
          responseText = response.data
        }

        this.backendResponse = String(responseText).replace(/^"|"$/g, '')
        this.postError = false

        // небольшой UX-редирект назад на список
        setTimeout(() => {
          this.$router.push({ name: 'Home' })
        }, 1200)
      } catch (err) {
        this.postError = true
        let errorText = ''
        if (err.response && err.response.data) {
          if (typeof err.response.data === 'object') {
            errorText = err.response.data.answer || err.response.data.error || 'Произошла ошибка при обновлении'
          } else {
            errorText = err.response.data
          }
        } else {
          errorText = 'Ошибка соединения с сервером'
        }
        this.backendResponse = String(errorText).replace(/^"|"$/g, '')
        // eslint-disable-next-line no-console
        console.error('Ошибка при обновлении автомобиля:', err)
      }
    }
  }
}
</script>

<style scoped>
/* стили из твоего примера — без изменений */
.error { border-color: #ff4444 !important; }
.error-message { color: #ff4444; font-size: 12px; margin-top: 5px; }

.header-section { display: flex; justify-content: space-between; align-items: center; margin-bottom: 32px; flex-wrap: wrap; gap: 16px; }
.card-title { font-size: 20px; font-weight: 600; color: #333; margin: 0; flex: 1; min-width: 200px; }
.button-group { display: flex; gap: 12px; flex-wrap: wrap; }
.btn-primary, .btn-secondary { min-width: 120px; height: 40px; padding: 0 20px; border: none; border-radius: 6px; font-size: 14px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; justify-content: center; gap: 6px; }
.btn-primary { background-color: #007bff; color: white; }
.btn-primary:hover { background-color: #0056b3; }
.btn-secondary { background-color: #6c757d; color: white; }
.btn-secondary:hover { background-color: #545b62; }
.form-section { max-width: 500px; }
.text-field { margin-bottom: 24px; }
.text-field__label { display: block; margin-bottom: 8px; font-weight: 500; color: #333; font-size: 14px; }
.text-field__input { width: 100%; max-width: 400px; padding: 10px 12px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; box-sizing: border-box; transition: border-color 0.2s ease; }
.text-field__input:focus { outline: none; border-color: #007bff; box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25); }
.text-field__input.error { border-color: #ff4444; box-shadow: 0 0 0 2px rgba(255, 68, 68, 0.25); }
.text-field__input:disabled { background-color: #f5f5f5; cursor: not-allowed; }
.result-section { text-align: center; padding: 40px 20px; }
.result-buttons { margin-top: 24px; }

@media (max-width: 768px) {
  .header-section { flex-direction: column; align-items: stretch; gap: 16px; }
  .button-group { justify-content: stretch; }
  .btn-primary, .btn-secondary { flex: 1; min-width: auto; }
  .text-field__input { max-width: 100%; }
  .form-section { max-width: 100%; }
}
@media (max-width: 480px) {
  .button-group { flex-direction: column; }
  .btn-primary, .btn-secondary { width: 100%; }
  .card { padding: 16px; }
  .header-section { margin-bottom: 24px; }
}
</style>
